
import React, { useState, useEffect } from "react";
import { cn } from "@/lib/utils";

interface LoadingMessageProps {
  onComplete?: () => void;
}

const LoadingMessage: React.FC<LoadingMessageProps> = ({ onComplete }) => {
  const [currentStage, setCurrentStage] = useState(0);
  const [dots, setDots] = useState("");
  
  const stages = [
    "Klara tenker",
    "Klara analyserer", 
    "Klara forbereder svar"
  ];
  
  // Handle dots animation
  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => {
        if (prev.length >= 3) return "";
        return prev + ".";
      });
    }, 400);
    
    return () => clearInterval(interval);
  }, []);
  
  // Handle stage progression
  useEffect(() => {
    if (currentStage < stages.length - 1) {
      const timer = setTimeout(() => {
        setCurrentStage(prev => prev + 1);
      }, 2000); // 2 seconds per stage
      
      return () => clearTimeout(timer);
    } else if (onComplete) {
      // Stay on final stage for a minimum time
      const timer = setTimeout(() => {
        onComplete();
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, [currentStage, onComplete]);
  
  return (
    <div className={cn(
      "flex w-full py-4 px-8",
      "bg-white"
    )}>
      <div className="w-full max-w-5xl mx-auto">
        <div className="w-full">
          <div className="whitespace-pre-wrap w-full leading-relaxed text-base text-muted-foreground italic">
            <div className="flex items-center">
              <span>{stages[currentStage]}</span>
              <span className="inline-block w-8 text-left">{dots}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingMessage;
